import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecordType } from '../contexts/recordTypeContext';
import BottomSelectionBar from '../components/BottomSelectionBar';
import { useAggregates } from '../contexts/AggregatesContext';
import { useTableColumns } from '../contexts/TableColumnContext';
import { configState, selectedRecordTypeState } from '../recoil/atoms';
import { useRecoilValue } from 'recoil';
import { selectedProjectsState } from '../recoil/atoms/project';

const BottomRecordTypeSelectorContainer: React.FC = () => {
  const { setSelectedRecordType } = useRecordType();
  const selectedRecordType = useRecoilValue(selectedRecordTypeState);
  const { aggregateDefinitions } = useRecoilValue(configState);
  const history = useHistory();
  const selectedProjects = useRecoilValue(selectedProjectsState);
  const [tabValue, setTabValue] = useState<string | null>(null);
  const { recordTypesData, updateScrollPosition, lastScrolledRef } = useAggregates();
  const { setCurrentAssetId } = useTableColumns();

  //clear tab override when a project is selected
  useEffect(() => {
    setTabValue(null);
  }, [selectedProjects]);

  useEffect(() => {
    if (selectedRecordType && recordTypesData && recordTypesData?.length) {
      const record = recordTypesData.find(data => data.value === selectedRecordType);
      if (!record) {
        const aggrDef = aggregateDefinitions.find(def => def.name === recordTypesData[0].value);
        if (!aggrDef) return;
        setSelectedRecordType(aggrDef);
      } else {
        return;
      }
    }
  }, [selectedRecordType, recordTypesData, selectedProjects]);

  const handleSelect = (value: string) => {
    const lastScrolledRow = lastScrolledRef.current;
    updateScrollPosition(tabValue as string, lastScrolledRow as number);
    if (aggregateDefinitions) {
      const selected = history.location.pathname.match(/^(\/[A-Z]\w+|mainpage)\/(.+)/)?.[2] || '';
      const path = `/${value}` + (selected ? '/' + selected : '');
      history.push(path);
      setTabValue(value);
      setCurrentAssetId(o => ({ ...o, location: 'tab' }));
    }
  };

  return <BottomSelectionBar value={selectedRecordType} options={recordTypesData || []} onSelect={handleSelect} />;
};

export default BottomRecordTypeSelectorContainer;
